import React from 'react';
import PropTypes from 'prop-types';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import s from '../../../../screens/staking/card-table/items/item.module.scss';
import ColumnEstimatedAprTitle from './title';
import theme from '../../../../theme';

const ColumnEstimatedApr = ({ percentInOMText, percentFromUniSwap }) => {
  const colors = useGetTheme();
  return (
    <>
      <ColumnEstimatedAprTitle isMobile />
      <div className={s.col}>
        <div>
          <div className={s.topLine} style={{ color: theme.palette.mantra.pink }}>
            {percentInOMText}
          </div>
          {percentFromUniSwap && (
            <div className={s.uniBottomPercent}>
              <div style={{ color: theme.palette.mantra.pink }} className={s.uniBottomPercentPlus}>
                +
              </div>

              <div>
                <div style={{ color: colors.text }}>{percentFromUniSwap}%</div>
                <div className={s.uniBottomPercentDesc}>
                  <div style={{ color: colors.text }}>
                    from
                    <br />
                    UniSwap
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

ColumnEstimatedApr.propTypes = {
  percentInOMText: PropTypes.string.isRequired,
  percentFromUniSwap: PropTypes.string,
};

export default ColumnEstimatedApr;
